import { render, staticRenderFns } from "./AtomDrillDown2.vue?vue&type=template&id=1be15265"
import script from "./AtomDrillDown2.vue?vue&type=script&lang=js"
export * from "./AtomDrillDown2.vue?vue&type=script&lang=js"
import style0 from "./AtomDrillDown2.vue?vue&type=style&index=0&id=1be15265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports